/**
 * Boot sequence: a short "establishing uplink" overlay before the hero
 * powers on. Skipped for repeat visits in the same session, for users who
 * prefer reduced motion, and on any key/pointer press.
 */

const wait = (ms: number) => new Promise<void>((r) => window.setTimeout(r, ms));

async function waitUnless(ms: number, cancelled: () => boolean): Promise<void> {
  const step = 40;
  for (let t = 0; t < ms && !cancelled(); t += step) await wait(step);
}

async function blink(el: HTMLElement, cancelled: () => boolean): Promise<void> {
  const frames: [string, number][] = [
    ['1', 70],
    ['0', 140],
    ['1', 90],
    ['0', 140],
    ['1', 80]
  ];
  for (const [opacity, ms] of frames) {
    if (cancelled()) break;
    el.style.opacity = opacity;
    await wait(ms);
  }
  el.style.opacity = '1';
}

export async function runBoot(): Promise<void> {
  const boot = document.getElementById('boot');
  if (!boot) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let seen = false;
  try {
    seen = sessionStorage.getItem('fsd:boot') === '1';
  } catch {
    /* storage unavailable: always boot */
  }
  if (reduce || seen) {
    boot.remove();
    return;
  }
  try {
    sessionStorage.setItem('fsd:boot', '1');
  } catch {
    /* ignore */
  }

  let skipped = false;
  const skip = () => {
    skipped = true;
  };
  window.addEventListener('keydown', skip, { once: true });
  boot.addEventListener('pointerdown', skip, { once: true });

  const status = boot.querySelector<HTMLElement>('[data-boot-status]');

  await wait(80);
  boot.classList.add('is-loading');
  await waitUnless(860, () => skipped);

  if (!skipped && status) {
    status.textContent = '// UPLINK ESTABLISHED';
    await blink(status, () => skipped);
    await waitUnless(180, () => skipped);
  }

  window.removeEventListener('keydown', skip);
  boot.classList.add('is-done');
  await wait(560);
  boot.remove();
}
